import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { UserProvider } from '../../providers/user';
import { TeamappProvider } from '../../providers/teamapp';
import { LoadingProvider } from '../../providers/loading';
import {FileTransfer} from "@ionic-native/file-transfer";
import {File} from "@ionic-native/file";

import { FileReadPage } from "../file-read/file-read";
/**
 * Generated class for the FilesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-files',
  templateUrl: 'files.html',
})
export class FilesPage {
  title: string = 'Files';
  files: any = [] ;
  constructor(public navCtrl: NavController, public navParams: NavParams,public userProvider: UserProvider, public teamappProvider: TeamappProvider, public loadingProvider: LoadingProvider) {
    if(this.navParams.get("title")) {
      this.title = this.navParams.get("title");
    }
  }

  loadFiles() {
    this.teamappProvider.http_request('action=get_documents&v=2', 'files', false, true).then(data => {
      this.files = data;
      console.log(this.files);
    });
  }

  ionViewDidEnter() {
    this.loadFiles();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad FilesPage');
  }


  onFileClick(file: any) {
    this.navCtrl.push(FileReadPage, {file: file});
  }

}



// WEBPACK FOOTER //
// ./src/pages/files/files.ts